import colors from 'styles/colors'

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 21,
    backgroundColor: colors.white
  },
  infoContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  logoContainer: {
    width: 45,
    height: 45,
    paddingTop: 2
  },
  signInText: {
    marginLeft: 10,
    fontFamily: 'Barlow',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: 0.23,
    color: colors.lightGray
  },
  description: {
    marginLeft: 37,
    fontFamily: 'Barlow',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '17px',
    color: colors.lightGray
  },
  signInButton: {
    height: 35,
    borderRadius: 20,
    backgroundColor: colors.primary,
    fontFamily: 'Barlow',
    fontWeight: 700,
    fontSize: 12,
    letterSpacing: '1.29px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: colors.white
  }
}
